import { RootState } from '@/app/redux/store';
import { getFromLocalStorage } from '@/common/utils/localStorage';
import { createSlice } from '@reduxjs/toolkit';

interface InsightsState {
  selectedStudentIds: string[];
  selectedGroupIds: string[];
  selectedTab: 'learners' | 'groups';
}

const initialState: InsightsState = {
  selectedStudentIds: [],
  selectedGroupIds: [],
  selectedTab: 'learners',
  ...getFromLocalStorage('insights'),
};

const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: {
    setSelectedStudentIds: (state, action) => {
      state.selectedStudentIds = action.payload;
    },
    setSelectedGroupIds: (state, action) => {
      state.selectedGroupIds = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});

export const { setSelectedStudentIds, setSelectedGroupIds, setSelectedTab } =
  insightsSlice.actions;

export default insightsSlice.reducer;

export const selectInsightsState = (state: RootState) => state.insights;
